import { FC, PropsWithChildren, useMemo } from "react";

import {
  RydeUiUnit,
  TPermissionAction,
  useHasPermissionsCheck,
} from "@ryde/shared";

import { AccessControlsMethodCheckEnum } from "./access-controls.models";

interface IActionsCheck {
  entity?: RydeUiUnit;
  action?: TPermissionAction;
}

interface IAccessControlsProps extends PropsWithChildren {
  actionsList: IActionsCheck[];
  methodCheck?: AccessControlsMethodCheckEnum;
}

export const AccessControls: FC<IAccessControlsProps> = ({
  actionsList,
  methodCheck = AccessControlsMethodCheckEnum.AND,
  children,
}) => {
  const { hasPermissionsCheck } = useHasPermissionsCheck();

  const hasAccess = useMemo(() => {
    if (methodCheck === AccessControlsMethodCheckEnum.AND) {
      return actionsList.every(hasPermissionsCheck);
    }

    return actionsList.some(hasPermissionsCheck);
  }, [actionsList, hasPermissionsCheck, methodCheck]);

  if (!hasAccess) {
    return null;
  }

  return <>{children}</>;
};
